import React, { useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
const math = require('mathjs');
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const SvsTimeGraph = React.memo(function (props) {
  const [options, setOptions] = useState({});
  const [lastSValue, setLastSValue] = useState(null);
  useEffect(() => {
    // Your data generation logic here
    const N = props.N;
    const T = props.T;
    const D = props.D;
    const k_a = props.k_a;
    const k_d = props.k_d;

    const start_time = 0;
    const end_time = 2 * 3600;
    const num_points = 100;
    const t_values = [];
    const S_values = [];

    for (let i = 0; i < num_points; i++) {
      const t = start_time + (i / (num_points - 1)) * (end_time - start_time);
      const tInHours = t; // Convert seconds to hours

      // Insert your S(t) calculation based on k_a, k_d, N, T, D here
      // Example calculation (you'll need to replace this with the actual formula):
      const b = (k_a * N) / (k_d + k_a * T) * Math.sqrt(k_d / D);
      const a1 = -b / 2 + Math.sqrt(b ** 2 / 4 - 1);
      const a2 = -b / 2 - Math.sqrt(b ** 2 / 4 - 1);
      const tau = k_d * t;
      const c1 =  a1 * Math.sqrt(tau)
      const c2 =  a2 * Math.sqrt(tau)
      const S_t =
        (a2 * math.exp(-1*c1 * c1) * (1 - math.erf(-1 * c1)) -
          a1 * math.exp(-1 * c2 * c2) * (1 - math.erf(-1 * c2))) /
        (a2 - a1);
        console.log(c2, math.exp(c2 * c2), 1 - math.erf(c2))
        t_values.push(tInHours);
      S_values.push(S_t);
    }
// console.log(S_values)
    const data = [
      {
        type: 'line',
        showInLegend: true,
        name: `k_d = ${k_d}`,
        dataPoints: t_values.map((t, i) => ({
          x: t,
          y: S_values[i],
        })),
      },
    ];

    const options = {
      axisX: {
        title: 'Time (hours)', // Update the X-axis label
        minimum: -100,
      },
      axisY: {
        title: 'S(t)',
        minimum: -0.0001,
        maximum: 1.001
      },
      data: data,
    };

    setOptions(options);
    const lastSValue = S_values[S_values.length - 1];
    setLastSValue(lastSValue); // Update the state with the last value
  }, [props.N, props.T, props.D, props.k_a, props.k_d]);

  return (
    <div className="interactive-graph">
      <CanvasJSChart options={options} />
      {/* Display the last value of S_values */}
      {lastSValue !== null && (
        <div>
          <p>The total surface probability after 2 hrs =  {lastSValue}</p>
        </div>
      )}
    </div>
  );
})


export default SvsTimeGraph;